import { PropsWithChildren, useState, useEffect } from "react";
import { PaymentWrapper } from "@made-people/blueprint-checkout";
import { Checkbox } from "@made-people/blueprint-form";
import { useTranslate } from "@made-people/grease-translations";
import { NEWSLETTER_SIGNUP_KEY } from "./MMNewsletterOrderListener";
import { useCountriesAndLanguages } from "@made-people/grease-countries-and-languages";

/**
 * Countries that are allowed to pre-select the newsletter signup checkbox.
 */
const ALLOWED_PRE_SELECTED_NEWSLETTER_COUNTRIES = [
  "AT",
  "BE",
  "BG",
  "CY",
  "CZ",
  "DE",
  "DK",
  "EE",
  "ES",
  "FI",
  "FR",
  "GR",
  "HR",
  "HU",
  "IE",
  "IT",
  "LT",
  "LU",
  "LV",
  "MT",
  "NL",
  "PL",
  "PT",
  "RO",
  "SE",
  "SI",
  "SK",
];

export const MMPaymentWrapper = (props: PropsWithChildren) => {
  const { currentCountryCode } = useCountriesAndLanguages();
  const [shouldSignupToNewsletter, setShouldSignupToNewsletter] = useState(
    ALLOWED_PRE_SELECTED_NEWSLETTER_COUNTRIES.includes(currentCountryCode),
  );
  const translate = useTranslate();

  useEffect(() => {
    sessionStorage.setItem(
      NEWSLETTER_SIGNUP_KEY,
      shouldSignupToNewsletter ? "true" : "false",
    );
  }, [shouldSignupToNewsletter]);

  return (
    <PaymentWrapper>
      <div className="mb-2 lg:mb-6">
        <Checkbox
          checked={shouldSignupToNewsletter}
          label={translate("Checkout_Newsletter_Signup_Label")}
          onChange={() =>
            setShouldSignupToNewsletter(!shouldSignupToNewsletter)
          }
        />
      </div>
      {props.children}
    </PaymentWrapper>
  );
};
